//
//
//
//
//
//
//
//
//
//

import ZoneSelect from './zone_select'
export default {
    components: {
        ZoneSelect
    },
    props: {
        selected: Object,
        zones: Array
    }
}
